import initialState from "./InitialState";
import { UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL } from "../actions/ActionTypes";

export const overrideReducer = (state = initialState.overrides, action: { type: string, [key: string]: any }) => {
    switch (action.type) {
        case UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL: {
            return { ...state, updatedPatientPhoneNumber: action.phoneNumber };
        }
        default: return state;
    }
}